import React from 'react';
import { View } from 'react-native';
import Helpers from '../../../../../Common/Helpers/AmountHelpers';
import { TranslationView } from '@levelapp/softfabric-ui';
import { styles } from './VideosViewStyle';
import { useWindowSizeContext } from '../../../../../Common/contexts/WindowSizeContext';

interface ProjectPropertyKey {
  key: string;
  projectPropertyType: {
    key: string;
  };
}

interface ProjectProperty {
  id: number | string;
  projectId: number;
  value?: string;
  projectPropertyKey: ProjectPropertyKey;
}

interface VideosViewProps {
  properties: ProjectProperty[];
}

export const VideosView = ({ properties }: VideosViewProps) => {
  const { height, width, isMobile } = useWindowSizeContext();

  const videosProperties = properties
    .filter(p => p.projectPropertyKey.projectPropertyType.key === 'VIDEOS')
    .map(p => ({ ...p }));

  const shouldAddExtraVideo = videosProperties.some(p => p.projectId === 159);
  const original = videosProperties.find(p => p.id === 255);

  if (shouldAddExtraVideo && original) {
    const extraVideo: ProjectProperty = {
      ...original,
      id: `custom-${original.id}`,
      value: 'https://play.pod.co/beebonds-podcast/goldorak-sebastien-bertin',
    };
    videosProperties.push(extraVideo);
  }

  if (videosProperties.length === 0) return null;

  let podcastTitleShown = false;

  return (
    <View style={styles.page}>
      <TranslationView style={styles.title}>videos</TranslationView>

      {videosProperties.map((property) => {
        const propertyValue =
          property.value || Helpers.getPropertyValue(property.projectPropertyKey.key, properties);

        if (!propertyValue) return null;

        const isYouOrVim = propertyValue.includes('you') || propertyValue.includes('vim');
        const frameWidth = isYouOrVim ? '90%' : isMobile ? width * 0.8 : width * 0.3;
        const isPodcast = propertyValue.includes('play.pod');
        const frameHeight = isPodcast
          ? 200
          : isYouOrVim
            ? height * 0.5
            : undefined;
        const shouldShowPodcastTitle = isPodcast && !podcastTitleShown;

        if (shouldShowPodcastTitle) podcastTitleShown = true;

        return (
          <React.Fragment key={property.id}>
            {shouldShowPodcastTitle && (
              <TranslationView style={styles.title}>Podcast</TranslationView>
            )}
            <View style={styles.iframe}>
              <iframe
                title={String(property.id)}
                style={{
                  border: 'none',
                  margin: 0,
                  overflow: 'hidden',
                  scrollbarWidth: 'none',      
                  msOverflowStyle: 'none'      
                }}
                scrolling="no"
                src={propertyValue}
                width={frameWidth}
                height={frameHeight}
                referrerPolicy="strict-origin-when-cross-origin"
              />
            </View>
          </React.Fragment>
        );
      })}
    </View>
  );
};

export default VideosView;
